import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Navigation
      'nav.expertises': 'Expertises',
      'nav.solutions': 'Solutions',
      'nav.realisations': 'Réalisations',
      'nav.team': 'Équipe',
      'nav.about': 'À propos',
      'nav.contact': 'Contact',
      'nav.quote': 'Demander un devis',
      'nav.blog': 'Blog',

      // Hero
      'hero.badge': 'Ingénierie IT · Réseaux · Cybersécurité — Yaoundé',
      'hero.title': 'L\'ingénierie qui sécurise votre transformation numérique',
      'hero.description': 'Nexus Africa Solutions conçoit, déploie et protège les infrastructures, réseaux et logiciels des entreprises et institutions camerounaises. Une vitrine d\'excellence, rapide et sécurisée.',
      'hero.btn1': 'Démarrer un projet',
      'hero.btn2': 'Nos expertises',

      // Services
      'services.title': 'Nos expertises',
      'services.subtitle': 'Une ingénierie complète, du réseau à la cybersécurité',
      'services.description': 'Cinq domaines de compétence pour bâtir, connecter et protéger votre système d\'information.',

      // Contact
      'contact.title': 'Discutons de votre projet',
      'contact.description': 'Un audit, une infrastructure, une application, un besoin de sécurité ? Décrivez votre projet — nous revenons vers vous rapidement.',
      'contact.btn': 'Demander un devis',
      'contact.email': 'contact@nexusafricasolutions.com',
      'contact.phone': '+237 6 56 32 45 38',
      'contact.address': 'Yaoundé, Cameroun',
      'contact.form.name': 'Nom',
      'contact.form.company': 'Société',
      'contact.form.email': 'E-mail professionnel',
      'contact.form.need': 'Votre besoin',
      'contact.form.message': 'Message',
      'contact.form.submit': 'Envoyer',
      'contact.form.success': 'Message envoyé avec succès!',
      'contact.form.error': 'Erreur lors de l\'envoi du message',

      // Login
      'login.title': 'Connexion',
      'login.description': 'Heureux de vous revoir. Identifiez-vous pour continuer.',
      'login.email': 'Adresse e-mail',
      'login.password': 'Mot de passe',
      'login.remember': 'Se souvenir de moi sur cet appareil',
      'login.forgot': 'Mot de passe oublié ?',
      'login.submit': 'Connexion',
      'login.signup': 'Créer un compte',
      'login.sso': 'Continuer avec Microsoft 365',

      // Blog
      'blog.title': 'Blog & Actualités',
      'blog.description': 'Les dernières actualités de Nexus Africa Solutions',

      // Common
      'common.loading': 'Chargement...',
      'common.error': 'Une erreur est survenue',
      'common.success': 'Succès',
      'common.learnMore': 'En savoir plus'
    }
  },
  en: {
    translation: {
      // Navigation
      'nav.expertises': 'Expertise',
      'nav.solutions': 'Solutions',
      'nav.realisations': 'Portfolio',
      'nav.team': 'Team',
      'nav.about': 'About',
      'nav.contact': 'Contact',
      'nav.quote': 'Get a Quote',
      'nav.blog': 'Blog',

      // Hero
      'hero.badge': 'IT Engineering · Networks · Cybersecurity — Yaoundé',
      'hero.title': 'Engineering that secures your digital transformation',
      'hero.description': 'Nexus Africa Solutions designs, deploys, and protects the infrastructure, networks, and software of Cameroonian businesses and institutions. A showcase of excellence, fast and secure.',
      'hero.btn1': 'Start a Project',
      'hero.btn2': 'Our Expertise',

      // Services
      'services.title': 'Our Expertise',
      'services.subtitle': 'Complete engineering, from networks to cybersecurity',
      'services.description': 'Five areas of expertise to build, connect, and protect your information system.',

      // Contact
      'contact.title': 'Let\'s Discuss Your Project',
      'contact.description': 'An audit, infrastructure, application, security need? Describe your project — we\'ll get back to you quickly.',
      'contact.btn': 'Get a Quote',
      'contact.email': 'contact@nexusafricasolutions.com',
      'contact.phone': '+237 6 56 32 45 38',
      'contact.address': 'Yaoundé, Cameroon',
      'contact.form.name': 'Name',
      'contact.form.company': 'Company',
      'contact.form.email': 'Work Email',
      'contact.form.need': 'Your Need',
      'contact.form.message': 'Message',
      'contact.form.submit': 'Send',
      'contact.form.success': 'Message sent successfully!',
      'contact.form.error': 'Error sending message',

      // Login
      'login.title': 'Sign In',
      'login.description': 'Glad to see you again. Sign in to continue.',
      'login.email': 'Email Address',
      'login.password': 'Password',
      'login.remember': 'Remember me on this device',
      'login.forgot': 'Forgot password?',
      'login.submit': 'Sign In',
      'login.signup': 'Create Account',
      'login.sso': 'Continue with Microsoft 365',

      // Blog
      'blog.title': 'Blog & News',
      'blog.description': 'Latest news from Nexus Africa Solutions',

      // Common
      'common.loading': 'Loading...',
      'common.error': 'An error occurred',
      'common.success': 'Success',
      'common.learnMore': 'Learn more'
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
